import { render, staticRenderFns } from "./menu-popover-placement.vue?vue&type=template&id=1da13086&"
import script from "./menu-popover-placement.vue?vue&type=script&lang=js&"
export * from "./menu-popover-placement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports